import React from "react";

const ShipingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5 5.93621H14.6155V4.37931C14.6155 4.08785 14.3777 3.85 14.0862 3.85H1.37931C1.08785 3.85 0.85 4.08785 0.85 4.37931V17.0862C0.85 17.3777 1.08785 17.6155 1.37931 17.6155H3.17971C3.42197 18.7533 4.43578 19.6069 5.64655 19.6069C6.85797 19.6069 7.86684 18.7527 8.11293 17.6155H14.0862H15.8866C16.1289 18.7533 17.1427 19.6069 18.3534 19.6069C19.5649 19.6069 20.5737 18.7527 20.8198 17.6155H22.6207C22.9122 17.6155 23.15 17.3777 23.15 17.0862V11.5862C23.15 8.46888 20.6173 5.93621 17.5 5.93621ZM17.5 6.99483C19.8692 6.99483 21.8224 8.79759 22.068 11.1043H18.5384C17.8338 11.1043 17.2565 10.5311 17.2565 9.82241V6.99483H17.5ZM13.5569 4.90862V13.0957H1.90862V4.90862H13.5569ZM5.64655 14.5655C4.43513 14.5655 3.42627 15.4197 3.18017 16.5569H1.90862V14.1543H13.5569V16.5569H8.1134C7.87114 15.4191 6.85732 14.5655 5.64655 14.5655ZM5.64655 18.5483C4.84276 18.5483 4.18448 17.89 4.18448 17.0862C4.18448 16.2824 4.84276 15.6241 5.64655 15.6241C6.45035 15.6241 7.10862 16.2824 7.10862 17.0862C7.10862 17.89 6.45035 18.5483 5.64655 18.5483ZM18.3534 18.5483C17.5497 18.5483 16.8914 17.89 16.8914 17.0862C16.8914 16.2824 17.5497 15.6241 18.3534 15.6241C19.1572 15.6241 19.8155 16.2824 19.8155 17.0862C19.8155 17.89 19.1572 18.5483 18.3534 18.5483ZM22.0914 16.5569H20.8203C20.578 15.4191 19.5642 14.5655 18.3534 14.5655C17.142 14.5655 16.1332 15.4197 15.8871 16.5569H14.6155V6.99483H16.1978V9.82241C16.1978 11.1143 17.2465 12.1629 18.5384 12.1629H22.0914V16.5569Z"
        fill="#3A393A"
        stroke="#3A393A"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export default ShipingIcon;
